import React from 'react';
import { Box, Chip, Typography } from '@mui/material';
import { FulfillmentLifecycleStatus, WaveStatus } from '../../services/fulfillment/types';
import {
  LIFECYCLE_STATUS_LABELS,
  LIFECYCLE_STATUS_COLORS,
} from '../../services/fulfillment/constants';

interface FulfillmentStatusChipProps {
  lifecycleStatus: FulfillmentLifecycleStatus | null;
  waveStatus: WaveStatus;
  waveId: number | null;
}

const FulfillmentStatusChip: React.FC<FulfillmentStatusChipProps> = ({
  lifecycleStatus,
  waveStatus,
  waveId,
}) => {
  const label = lifecycleStatus ? LIFECYCLE_STATUS_LABELS[lifecycleStatus] : 'Unknown';
  const colors = lifecycleStatus
    ? LIFECYCLE_STATUS_COLORS[lifecycleStatus]
    : { bg: '#eeeeee', color: '#616161' };

  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start" gap={0.5}>
      <Chip
        label={label}
        size="small"
        sx={{ backgroundColor: colors.bg, color: colors.color, fontWeight: 500 }}
      />
      {waveStatus === 'exception' && <Chip label="Exception" size="small" color="error" />}
      {waveStatus === 'in_wave' && (
        <Typography variant="caption" color="text.secondary">
          Wave #{waveId}
        </Typography>
      )}
    </Box>
  );
};

export default FulfillmentStatusChip;
